<template>
  <div class="bg-gray-200 rounded-xl p-1 absolute top-0 right-0 mr-3 mt-3">
    <button class="bg-yellow-500 rounded-l-lg p-2 mr-0.5" @click="playAudio">
      <img src="../assets/icon/play.svg" width="20" height="20" alt="play">
    </button>
    <button class="bg-yellow-500 rounded-r-lg p-2 ml-0.5" @click="pauseAudio">
      <img src="../assets/icon/pause.svg" width="20" height="20" alt="pause">
    </button>
  </div>
</template>

<script>
import { Howl } from 'howler';

export default {
  name: 'AudioPlayer',
  data() {
    return {
      play: false,
      audio: null, // Will hold the Howl instance
    };
  },
  methods: {
    // Initialize Howler.js with the audio file
    initAudio() {
      this.audio = new Howl({
        src: ["music/instrument.mp3"], // Path to your audio file in the public folder
        autoplay: false, // Don't autoplay
        loop: true, // Set to true if you want looping
        volume: 1, // Volume level (0 to 1)
      });
    },

    // Play the audio
    playAudio() {
      if (!this.play) {
        if (!this.audio) {
          this.initAudio();
        }
        
        this.play = true;
        this.audio.play();
      }
    },

    // Pause the audio
    pauseAudio() {
      if (this.audio && this.play) {
        this.play = false;
        this.audio.pause();
      }
    },

    // Stop the audio
    stopAudio() {
      if (this.audio && this.play) {
        this.play = false;
        this.audio.stop();
      }
    },
  },
};
</script>
